import { render, staticRenderFns } from "./LBdetail.vue?vue&type=template&id=247a5b37&"
import script from "./LBdetail?vue&type=script&lang=ts&"
export * from "./LBdetail?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports